module.exports = __webpack_public_path__ + "assets/hotel.8c278d1a.svg";